import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { Tag } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

const subTags: Partial<SubWebsocketMessageRequest> = {
  view: 'pln',
  s: 'model',
};

@Injectable({
  providedIn: 'root',
})
export class TagManagerService extends HttpEntityManager<Tag, Tag> {
  protected http = inject(HttpClient);
  private webSocketService = inject(WebSocketService);

  entityName: WebsocketEntTypes = 'tag';
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);

  constructor() {
    super();
  }

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...subTags, ...payload }, true);
  }

  createTag(tag: Pick<Tag, 'name' | 'desc' | 'color' | 'icon'>) {
    this.wsManager.create({ res: tag });
  }

  updateTag(tag: Pick<Tag, 'name' | 'desc' | 'color' | 'icon' | '_id'>) {
    this.wsManager.update({ res: tag, id: tag._id });
  }

  deleteTag(tag: Pick<Tag, '_id'>) {
    this.wsManager.delete({ id: tag._id });
  }
}
